import { CellContainer } from "../CellContainer";
import { CellFetchProps } from "./types";
import { StyledText } from "./styles";

import { StyledLink } from "../CellLink/styles";
import { CircularProgress } from "@mui/material";

export const CellFetch = ({
  align = "start",
  direction,
  gap,
  color,
  fontWeight,
  textAlign,
  resourceHook,
  id,
  valueKey,
  link,
}: CellFetchProps) => {
  const { data, isLoading } = resourceHook({
    ids: [id],
  });

  return (
    <CellContainer align={align} direction={direction} gap={gap}>
      {isLoading && (
        <CircularProgress
          size={20}
          sx={{
            color: "#000",
            margin: "0 auto",
          }}
        />
      )}
      {link ? (
        <StyledLink
          color={color}
          to={link ? `${link}/${id}` : "#"}
          className={!data?.length ? "empty" : ""}
        >
          {data?.length > 0 ? data[0][valueKey] : "-"}
        </StyledLink>
      ) : data?.length > 0 ? (
        <StyledText
          color={color}
          fontWeight={fontWeight}
          textAlign={textAlign}
          className={!data?.length ? "empty" : ""}
        >
          {data?.length > 0 ? data[0][valueKey] : "-"}
        </StyledText>
      ) : data && typeof data[valueKey] !== "undefined" ? (
        <StyledText color={color} fontWeight={fontWeight} textAlign={textAlign}>
          {data[valueKey]}
        </StyledText>
      ) : (
        <StyledText
          color={color}
          fontWeight={fontWeight}
          textAlign={textAlign}
          className={"empty"}
        >
          -
        </StyledText>
      )}
    </CellContainer>
  );
};

CellFetch.displayName = "CellFetch";
